export default "__VITE_ASSET__D3nkB3eZ__"